/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1IndividualpaymentPeoplePersonidCoursesQueryResponse,
  GetApiV1IndividualpaymentPeoplePersonidCoursesPathParams,
  GetApiV1IndividualpaymentPeoplePersonidCoursesQueryParams,
  GetApiV1IndividualpaymentPeoplePersonidCourses401,
  GetApiV1IndividualpaymentPeoplePersonidCourses500,
} from "../../types/individualPaymentController/GetApiV1IndividualpaymentPeoplePersonidCourses.ts";

function getGetApiV1IndividualpaymentPeoplePersonidCoursesUrl(
  personId: GetApiV1IndividualpaymentPeoplePersonidCoursesPathParams["personId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/individualpayment/people/${personId}/courses` as const,
  };
  return res;
}

/**
 * @description Retorna os planos financeiros da pessoa com nome do curso, situação calculada (bolsista, finalizado, em dia, atrasado, inativo), status de bolsa e valor com transferências e descontos abatidos. Filtros por nosso número, nota fiscal e CPF/CNPJ de terceiro. A empresa do usuário autenticado restringe as matrículas. Migrado do legado IndividualPayment/LoadGridDataAsyncCourses. **(Requer Authorization para autenticação)**
 * @summary Retorna os planos financeiros/cursos de uma pessoa (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/people/:personId/courses}
 */
export async function getApiV1IndividualpaymentPeoplePersonidCourses(
  personId: GetApiV1IndividualpaymentPeoplePersonidCoursesPathParams["personId"],
  params?: GetApiV1IndividualpaymentPeoplePersonidCoursesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1IndividualpaymentPeoplePersonidCoursesQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentPeoplePersonidCourses401
      | GetApiV1IndividualpaymentPeoplePersonidCourses500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1IndividualpaymentPeoplePersonidCoursesUrl(
      personId,
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
